var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8607_8808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 16.625H6.125C4.05393 16.625 2.375 18.3039 2.375 20.375V31.625C2.375 33.6961 4.05393 35.375 6.125 35.375H24.875C26.9461 35.375 28.625 33.6961 28.625 31.625V20.375C28.625 18.3039 26.9461 16.625 24.875 16.625Z",
    stroke: "#D7D7D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.875C16.5355 27.875 17.375 27.0355 17.375 26C17.375 24.9645 16.5355 24.125 15.5 24.125C14.4645 24.125 13.625 24.9645 13.625 26C13.625 27.0355 14.4645 27.875 15.5 27.875Z",
    stroke: "#D7D7D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16.625V9.125C8 7.13588 8.79018 5.22822 10.1967 3.8217C11.6032 2.41518 13.5109 1.625 15.5 1.625C17.4891 1.625 19.3968 2.41518 20.8033 3.8217C22.2098 5.22822 23 7.13588 23 9.125V16.625",
    stroke: "#D7D7D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8607_8808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e2c39093150b07e50c34499644f4e6fd.svg";
export { ForwardRef as ReactComponent };